import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import initialValues from "./schemas/initialValues";
import form from "./schemas/form";
import validations from "./schemas/validations";
import axios from "axios";
import {API_URL} from "../../../config";
import {resetPasswordService} from "../../../services/authService";

export const useResetPassword = () => {

    const [searchParams, setSearchParams] = useSearchParams();

    const [values, setValues] = useState(initialValues);

    const [isLoading, setIsLoading] = useState(true);

    const {formId, formField} = form;

    const [snackbarConfig, setSnackbarConfig] = useState({
        color: 'succcess',
        title: '',
        message: '',
        icon: 'notifications'
    });
    const [show, setShow] = useState(false);
    const toggleSnackbar = () => setShow(!show);

    useEffect(() => {

        let token = searchParams.get('token');

        let newValues = {...values};
        newValues.token = token;

        setValues(newValues);

        setIsLoading(false)

    }, []);

    const submitForm = async (values, actions) => {

        try {

            // Enviar datos a API
            const response = await resetPasswordService(values);

            actions.resetForm();

            setSnackbarConfig({
                message: 'Contraseña restablecida exitosamente.',
                icon: 'notifications',
                title: 'Autenticación',
                color: 'success'
            });

            setShow(true);

        } catch (error) {

            setSnackbarConfig({
                message: error.response.data.message,
                icon: 'cancel',
                title: 'Autenticación',
                color: 'warning'
            });

            setShow(true);

        }

        actions.setSubmitting(false);

    };

    return { snackbarConfig, formId, formField, validations, values, show, isLoading, toggleSnackbar, submitForm };
}
